
import './App.css';
import FormComponent from './FormComponent/FormComponent';

function App() {
  return (
    <div className="App">
      <FormComponent />
    </div>
  );
}

export default App;
